import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAbstractionByRegnoFetchUrl,
  IAbstractionResponse,
} from "../../../../api/Abstractions/IAbstractions";
import { RootState } from "../../../../redux/store";

export interface AbstractionState {
  fetchStatus: string;
  error: any;
  abstractionResponse?: IAbstractionResponse;
}

const initialState: AbstractionState = {
  error: undefined,
  fetchStatus: "Loading...",
  abstractionResponse: undefined,
};

export const loadAbstractionAsync = createAsyncThunk(
  "abstraction/load",
  async (regNo: string) => {
    const response = await GetAbstractionByRegnoFetchUrl(regNo);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const abstractionSlice = createSlice({
  name: "abstraction",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadAbstractionAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadAbstractionAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.abstractionResponse = action.payload;
      })
      .addCase(loadAbstractionAsync.rejected, (state, action) => {
        state.fetchStatus = "rejected";
        state.error = action.payload;
      });
  },
});

export const selectAbstractionResponse = (state: RootState) =>
  state.abstractionResponse;

export default abstractionSlice.reducer;
